import { render } from "./ScirtScreenIntro.vue?vue&type=template&id=f2a262ea&scoped=true&ts=true"
import script from "./ScirtScreenIntro.vue?vue&type=script&lang=ts"
export * from "./ScirtScreenIntro.vue?vue&type=script&lang=ts"

import "./ScirtScreenIntro.vue?vue&type=style&index=0&id=f2a262ea&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a262ea"]])

export default __exports__